import { Config, GenderEnum } from "@/domains/createCharacter/constants/general";

export default function parseConfig(data: Record<string, any>): Config {
  const result: Config = {
    [GenderEnum.Male]: {
      hairs: [],
      hats: [],
      legs: [],
      shoes: [],
      tops: [],
    },
    [GenderEnum.Female]: {
      hairs: [],
      hats: [],
      legs: [],
      shoes: [],
      tops: [],
    },
  };

  (Object.values(GenderEnum) as GenderEnum[]).forEach((gender) => {
    result[gender].hairs = data.hairs[gender];
    result[gender].hats = data.hats[gender];
    result[gender].legs = data.legs[gender];
    result[gender].shoes = data.shoes?.[gender];
    result[gender].tops = data.tops?.[gender];
  });

  return result;
}
